import { render, staticRenderFns } from "./formdata.vue?vue&type=template&id=a6ccb0ac&scoped=true"
import script from "./formdata.vue?vue&type=script&lang=js"
export * from "./formdata.vue?vue&type=script&lang=js"
import style0 from "./formdata.vue?vue&type=style&index=0&id=a6ccb0ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ccb0ac",
  null
  
)

export default component.exports